import { render, staticRenderFns } from "./PickCard.vue?vue&type=template&id=2ca0a478&"
import script from "./PickCard.vue?vue&type=script&lang=js&"
export * from "./PickCard.vue?vue&type=script&lang=js&"
import style0 from "./PickCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports